import React from 'react';
import { IonText } from '@ionic/react';
import MaintenanceCard from './MaintenanceCard';

interface IProps {
    maintenances: any[];
}

const Maintenances: React.FC<IProps> = (props) => {
    return (
        <>
            {Array.isArray(props.maintenances) && props.maintenances.map((maintenance, index) => <MaintenanceCard maintenance={maintenance} key={index} />)}
            {(!Array.isArray(props.maintenances) || props.maintenances.length === 0) && (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '48px 24px', gap: '8px' }}>
                    <IonText color="medium" style={{ fontSize: '14px' }}>No maintenances found</IonText>
                    <IonText color="medium" style={{ fontSize: '13px' }}>Pull to refresh</IonText>
                </div>
            )}
        </>
    );
};

export default Maintenances;
